<script setup>
import { computed, getCurrentInstance } from 'vue';
import Button from "../../common/Button.vue";

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const betaMode = computed(() => store.state.betaMode);
const alphaMode = computed(() => store.state.alphaMode);

// --- Methods ---

const addToast = () => {
    store.dispatch('toasts/add', {
        title: 'Duis aute irure',
        body: 'Lorem ipsum dolor sit amet.'
    });
};

const addToastNoTitle = () => {
    store.dispatch('toasts/add', {
        body: 'Lorem ipsum dolor sit amet.'
    });
};

const addToastWarning = () => {
    store.dispatch('toasts/add', {
        body: 'This has auto hide disabled.',
        colourScheme: 'warning',
        disableAutoHide: true
    });
};

const addToastDanger = () => {
    store.dispatch('toasts/add', {
        body: 'This has auto hide disabled.',
        colourScheme: 'danger',
        disableAutoHide: true
    });
};
</script>

<template>
    <div class="card mb-3">
        <div class="card-header">
            Introduction
        </div>

        <div class="card-body">
            <p class="lead">Welcome to CreativeCMS</p>
            <div class="row">
                <div class="col-sm-6"></div>
                <div class="col-sm-6"></div>
            </div>
        </div>

        <div v-if="betaMode">
            <Button @click.native="addToast">
                Toast
            </Button>

            <Button @click.native="addToastNoTitle">
                Simple toast
            </Button>

            <Button @click.native="addToastWarning">
                Warning
            </Button>

            <Button @click.native="addToastDanger">
                Danger
            </Button>
        </div>

        <span v-if="alphaMode">
            </span>
    </div>
</template>

<style scoped>
/* Scoped styles preserved empty */
</style>